module.exports = __webpack_public_path__ + "static/emma-turnball-9480b7b0ac225471d813b80c9798700d.jpg";